/** Site-wide details: navigation, contact, store links. */

export const site = {
  name: "אפלאטס",
  nameEn: "Applates",
  email: "info@applates.info",
  // No public phone or WhatsApp number for now — every contact path goes
  // through the lead form, which also keeps the funnel measurable.
  phone: null,
};

// `icon` is shown in the mobile drawer only.
export const navLinks = [
  { label: "למה אפלאטס", target: "features", icon: "IconSparkle" },
  { label: "איך זה עובד", target: "how-it-works", icon: "IconClipboard" },
  { label: "המלצות", target: "testimonials", icon: "IconQuote" },
  // Restore alongside <PricingSection /> in HomeView.vue.
  // { label: "מחירים", target: "pricing", icon: "IconChart" },
  { label: "שאלות נפוצות", target: "faq", icon: "IconHelp" },
];

export const storeLinks = {
  ios: "https://apps.apple.com/il/app/applates/id1618283239",
  android:
    "https://play.google.com/store/apps/details?id=com.applates.applates2",
};

export const legalLinks = [
  { label: "תנאי שימוש", to: "/terms" },
  { label: "מדיניות הפרטיות", to: "/privacy" },
];
